import { Box, Divider } from "@mui/material";
import PSRWageProcessedEmp from "../Reports/PSRDailyWage/PSRWageProcessedEmp";
import PSRWageNotProcessedEmp from "../Reports/PSRDailyWage/PSRWageNotProcessedEmp";

const WorkBasedEmployees = ({
  selectedYear,
  selectedMonth,
  currentMonthData,
  userRole,
  paydate,
  worklocationData,
  handleWorkLoacation,
}) => {
  const readOnly = () => {
    if (userRole === "both") {
      if (currentMonthData?.["Work-Based_status"] === "Action Needed") {
        return true;
      } else {
        return false;
      }
    } else if (userRole === "approver") {
      return true;
    } else if (userRole === "admin") {
      return currentMonthData?.["Work-Based_status"] === "Action Needed";
    }
  };
  return (
    <Box>
      <PSRWageProcessedEmp
        selectedYear={selectedYear}
        selectedMonth={selectedMonth}
        currentMonthData={currentMonthData}
        userRole={userRole}
        readOnly={readOnly()}
        paydate={paydate}
        worklocationData={worklocationData}
        handleWorkLoacation={handleWorkLoacation}
      />
      <Divider sx={{ my: 3 }} />
      <PSRWageNotProcessedEmp
        selectedYear={selectedYear}
        selectedMonth={selectedMonth}
        readOnly={readOnly()}
        paydate={paydate}
        worklocationData={worklocationData}
        handleWorkLoacation={handleWorkLoacation}
      />
    </Box>
  );
};

export default WorkBasedEmployees;
